KROWN.themeName = 'Highlight';
KROWN.themeVersion = '4.1.0';

// Capped at the 1440px site width set in theme.css; --page-width keeps the full width for edge-to-edge colour
const setGridPerfectWidth = ()=>{
  const width = document.documentElement.clientWidth;
  document.documentElement.style.setProperty('--grid-perfect-width', Math.min(width, 1440) + 'px');
  document.documentElement.style.setProperty('--page-width', width + 'px');
};
setGridPerfectWidth();
window.addEventListener('resize', setGridPerfectWidth);

// A capped section with its own colour (often editor custom CSS) paints that colour out to both screen edges
const bleedSectionColours = ()=>{
  document.querySelectorAll('#main > .shopify-section').forEach(section=>{
    const colour = getComputedStyle(section).backgroundColor;
    if ( colour === 'rgba(0, 0, 0, 0)' || colour === 'transparent' ) return;
    section.style.boxShadow = `calc(1px - var(--site-max)) 0 0 0 ${colour}, calc(var(--site-max) - 1px) 0 0 0 ${colour}`;
  });
};
if ( document.readyState !== 'loading' ) {
  bleedSectionColours();
} else {
  document.addEventListener('DOMContentLoaded', bleedSectionColours);
}
document.addEventListener('shopify:section:load', bleedSectionColours);

const executeOnceOnDomContentLoaded = ()=>{

  // tab navigation

  document.querySelectorAll('.css-slider, .product-variant__input, .simple-arrow, .mount-header [tabindex]').forEach(elm=>{
    elm.addEventListener('blur', e=>{
      e.currentTarget.classList.remove('focus');
    })
  });

  let activeElement = document.activeElement;
  document.addEventListener('keyup', e=>{
    if ( e.keyCode == window.KEYCODES.TAB ) {
      if ( activeElement.classList.contains('focus') && e.target != activeElement ) {
        activeElement.classList.remove('focus');
      }
      if ( e.target.classList.contains('css-slider') ||
        e.target.classList.contains('product-variant__input') ||
        e.target.classList.contains('simple-arrow') || 
        e.target.getAttribute('tabindex') != '-1'
      ) {
        e.target.classList.add('focus');
      }
      activeElement = document.activeElement;
    }
  });

  // newsletter has jump

  if ( window.location.pathname.includes('/challenge') ) {
    setTimeout(()=>{
      window.scroll({
        top: 0, 
        behavior: 'auto'
      });
    }, 300);
  }

  // fix image link borders

  document.querySelectorAll('.rte a img').forEach(elm=>{
    elm.parentNode.style.border = 'none';
  });

}

if ( document.readyState !== 'loading' ) {
  executeOnceOnDomContentLoaded();
} else {
  document.addEventListener('DOMContentLoaded', executeOnceOnDomContentLoaded);
}

// method for apps to tap into and refresh the cart

if ( ! window.refreshCart ) {

	window.refreshCart = () => {
		
		fetch('?section_id=helper-cart')
			.then(response => response.text())
			.then(text => {

				const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html');
				const cartFormInnerHTML = sectionInnerHTML.getElementById('AjaxCartForm').innerHTML;
				const cartSubtotalInnerHTML = sectionInnerHTML.getElementById('AjaxCartSubtotal').innerHTML;

				const cartItems = document.getElementById('AjaxCartForm');
				cartItems.innerHTML = cartFormInnerHTML;
				
				// Fix: Call ajaxifyCartItems on the cart-form custom element, not the DOM element
				const cartForm = cartItems.closest('cart-form') || document.querySelector('cart-form');
				if (cartForm && typeof cartForm.ajaxifyCartItems === 'function') {
					cartForm.ajaxifyCartItems();
				}
				
				// Use cart.js to get updated cart data for consistent updates
				fetch('/cart.js')
					.then(response => response.json())
					.then(cartData => {
						const cartFormElement = document.querySelector('cart-form');
						
						// Use consistent update methods if cart form exists
						if (cartFormElement && typeof cartFormElement.updateCartCountElements === 'function') {
							cartFormElement.updateCartCountElements(cartData);
							cartFormElement.updateCartTotalElements(cartData);
							cartFormElement.updateCartTextElements(cartData);
							cartFormElement.updateSubtotalElements(cartData);
						} else {
							// Fallback to direct updates
							const headerCartCount = document.querySelector('[data-header-cart-count]');
							const cartCount = cartItems.querySelector('[data-cart-count]');
							if (headerCartCount && cartCount) {
								headerCartCount.textContent = cartCount.textContent;
							}
						}
						
						// Dispatch cart-updated event for consistency
						const event = new CustomEvent('cart-updated', {
							bubbles: true,
							detail: {
								source: 'theme-refresh-cart',
								cartData: cartData,
							},
						});
						document.dispatchEvent(event);
					})
					.catch(error => {
						console.error('Error fetching cart data:', error);
						// Fallback to original method
						const headerCartCount = document.querySelector('[data-header-cart-count]');
						const cartCount = cartItems.querySelector('[data-cart-count]');
						if (headerCartCount && cartCount) {
							headerCartCount.textContent = cartCount.textContent;
						}
					});

				document.getElementById('AjaxCartSubtotal').innerHTML = cartSubtotalInnerHTML;
				
				const cartSidebar = document.getElementById('site-cart-sidebar');
				if (cartSidebar && typeof cartSidebar.show === 'function') {
					cartSidebar.show(null);
				}

		})

	}

}